import React, { memo } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Account, SignOut } from '../../';
import { ScrollProvider } from '../ScrollProvider';
import { Wrapper } from './AppContent.Styles';
export var AppContent = memo(function (_a) {
    var accountRoute = _a.accountRoute, signOutRoute = _a.signOutRoute, children = _a.children;
    return (React.createElement(ScrollProvider, null,
        React.createElement(Wrapper, null,
            React.createElement(Route, { path: signOutRoute },
                React.createElement(SignOut, null)),
            React.createElement(Switch, null,
                React.createElement(Route, null, children)),
            React.createElement(Route, { path: accountRoute },
                React.createElement(Account, null)))));
});
